import { useEffect } from "react"
import AdvisorGift from "@/assets/img/advisors/advisor-gift.webp"

/** Warms the advisor-gift image used by the post-login popup. Ported from Advisors.hooks. */
export function usePreloadImages() {
  useEffect(() => {
    window.preloadImagesCompatibility = [AdvisorGift].map((src) => {
      const img = new Image()
      img.src = src
      return img
    })
  }, [])
}
